import { TOUR_TRANSLATIONS } from "../translations"

export const getFlashOffersSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="flash-offers-tabs"]',
            title: t.flashOffersTabs.title,
            content: t.flashOffersTabs.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="flash-offers-table"]',
            title: t.flashOffersTable.title,
            content: t.flashOffersTable.content,
        },
        {
            target: '[data-tour="flash-offers-create-report"]',
            title: t.flashOffersCreateReport.title,
            content: t.flashOffersCreateReport.content,
        },
    ]
}
